<template>
    <PageBase class="content-background-forms">
        <home-header v-if="isJACareerEntrepreApp" />
        <router-view></router-view>
    </PageBase>
</template>

<script>
    import PageBase from '../../../core/Components/PageBase.vue'
    import HomeHeader from '../Components/HomeHeader'

    export default {
        name: "HomeView",
        components: {
            PageBase,
            HomeHeader
        }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"

    .content-background-forms
        background-color color-1
</style>
